import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=4e13743a&"
import script from "./CustomerOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports